// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"658":"3b53517f","4049":"3ed17a50","6508":"3b53517f","9204":"3ed17a50"}[chunkId] + ".chunk.css";
};